import Loading from "./loading";
import { useContext } from "react";
import BusinessContext from "../../contexts/business-context";
import UserContext from "../../contexts/user-context";

const Loader = ({ children }) => {
  const businessCtx = useContext(BusinessContext);

  const business = businessCtx.activeBusiness;
  const userCtx = useContext(UserContext);
  const user = userCtx.user;
  if (business == null || user == null) return <Loading />;

  return children;
};

export default Loader;
